import React, { useState } from 'react';

import BrandsData from '../Data/BrandsData';
import MusicPlayer2 from '../Tools/MusicPlayer2';
// import BottomPlayBar from '../Tools/BottomPlayBar';

// import video_black from '../../Images/video_black.svg';
// import headphones_black from '../../Images/headphones_black.svg';
import play_circle from '../../Images/play-circle.svg';
// import pause_circle from '../../Images/pause-circle.svg';
import Cross from '../../Images/x.svg';

import './List.css';

const ListItem = ({item,itt,width,selected,setSelected,dimensions,playPressed,playing,setPlaying,playBack,setPlayBack,audioRef}) => {
	const [ hover, setHover ] = useState(false);
	// const [ videoAudio, setVideoAudio ] = useState('');
	// const [ playing, setPlaying ] = useState('');

	function itemClicked() {
		setPlaying('');
		setPlayBack(0);
		audioRef.current = undefined;
		if(selected === item.name){
			setSelected('');
			// setVideoAudio('');
		} else {
			setSelected(item.name);
			if(item.clips[0] !== undefined){
				// setVideoAudio({type:'video',content:item.clips[0]});
			} else if(item.songs[0] !== undefined){
				// setVideoAudio({type:'audio',content:item.songs[0]});
				setTimeout(()=>{
					const ref = document.getElementById(item.songs[0].name);
					audioRef.current = ref;
					playPressed(item.songs[0].name,itt);
				},200);
			}
		}
	}

	function mouseEnter() { setHover(true); }
	function mouseLeave() { setHover(false); }


	function videoClicked() {
		if(playing.id !== undefined){
			playPressed(playing.id,playing.i);
		}
	}

	// function audioAndVideoUpdate(e) {
	// 	setVideoAudio('');
	// 	setTimeout(()=>{
	// 		setVideoAudio(e);
	// 	},50);
	// }

	// function playPressed(e,i) {
	// 	const audio = document.getElementById(e);
	// 	if(playing.id === e){
	// 		if(playing.play === true){
	// 			audio.pause();
	// 			setPlaying({id:e,i:i,play:false});
	// 		} else {
	// 			audio.play();
	// 			setPlaying({id:e,i:i,play:true});
	// 		}
	// 	} else {
	// 		// stop previously playing song if playing
	// 		if(playing.play === true){
	// 			const audio_old = document.getElementById(playing.id);
	// 			audio_old.pause();
	// 		}
	// 		audio.play();
	// 		setPlaying({id:e,i:i,play:true});
	// 	}
	// }


	function informationPoints() {
		let arr = [];
		for(let i = 0; i < item.info.length; i++){
			arr.push(<div key={i}>{item.info[i]}</div>)
		}
		if(arr.length === 0) return null;
		return(
			<div>
				<div className='bold'>Info</div>
				{arr}
			</div>
		)
	}
	// function videoOrAudio(wide,high) {
	// 	if(videoAudio.type === 'video'){
	// 		return <video loop={false} autoPlay={true} width={'100%'} controls={true}
	// 				// ref={vidRef}
	// 				>
	// 			<source src={videoAudio.content.video} type="video/mp4" />
	// 		</video>
	// 	} else if(videoAudio.type === 'audio'){
	// 		return(
	// 			<div style={{height:'100%',width:'100%'}}>
	// 				<div className='absolute' style={{zIndex:4,width:wide,overflow:'hidden'}}>
	// 					<MusicPlayer2 song={videoAudio.content} id={videoAudio.content.name} playPressed={playPressed} playing={playing} width={wide} height={high} item={item} />
	// 				</div>
	// 				{/*<div className='flexCenter pointer absolute' style={{height:high,width:wide,zIndex:2,backgroundImage:'radial-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0))'}}>
	// 					<img src={play_circle} alt='play-circle' style={{height:70}} />
	// 				</div>
	// 				<div className='flexCenter pointer' style={{height:'100%',width:'100%'}}>
	// 					<img src={item.thumbnail} alt='play-circle' style={{height:'94%'}} />
	// 				</div>*/}
	// 			</div>
	// 		)
	// 	} else {
	// 		return(
	// 			<div style={{width:wide,height:high}}>
	// 				<div className='flexCenter absolute' style={{height:high,width:wide,overflow:'hidden'}}>
	// 					<img src={item.thumbnail} alt='play-circle' style={{height:'94%'}} />
	// 				</div>
	// 				<div className='flexCenter bold relative' style={{height:'100%',width:'100%',color:'white',zIndex:2,
	// 						backgroundImage:'radial-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0))',textShadow:'0px 0px 8px rgba(0,0,0,1)'}}>
	// 					{/*<img src={play_circle} alt='play-circle' style={{height:70,opacity:0.3}} />*/}
	// 					Select from the media
	// 				</div>
	// 			</div>
	// 		)
	// 	}
	// }

	function brandsDisplay2() {
		if(item.brands !== undefined){
			let arr = [];
			let wide = 40;
			if(dimensions.width < 800) wide = 30;
			if(dimensions.width < 600) wide = 20;
			for(let i = 0; i < item.brands.length; i++){
				if(BrandsData[item.brands[i]] !== undefined){
					arr.push(
						<div key={i}>
							<img src={BrandsData[item.brands[i]].img_light} alt='brand' style={{height:wide,marginLeft:14}} />
						</div>
					)
				}
			}
			return <div className='flexHeightCenter'>{arr}</div>
		}
	}
	// function mediaDisplayer() {
	// 	return(
	// 		<div className='flexCenter'>
	// 			<div className='flexCenter' style={{width:'33%',height:220}}>
	// 				<div className='flexCenter' style={{width:'92%',height:'80%',border:'1px solid rgba(255,255,255,0.2)',background:'black',color:'white'}}>
	// 					1
	// 				</div>
	// 			</div>
	// 			<div className='flexCenter' style={{width:'33%',height:220}}>
	// 				<div className='flexCenter' style={{width:'92%',height:'80%',border:'1px solid rgba(255,255,255,0.2)',background:'black',color:'white'}}>
	// 					2
	// 				</div>
	// 			</div>
	// 			<div className='flexCenter' style={{width:'33%',height:220}}>
	// 				<div className='flexCenter' style={{width:'92%',height:'80%',border:'1px solid rgba(255,255,255,0.2)',background:'black',color:'white'}}>
	// 					3
	// 				</div>
	// 			</div>
	// 		</div>
	// 	)
	// }
	function clipsAndMedia() {
		let vids = [];
		let arr = [];
		let count = 0;
		// let textHeight = 18;
		let playHigh = 70;
		if(dimensions.width < 700){
			// textHeight = 16;
			playHigh = 50;
		}
		if(dimensions.width < 500) playHigh = 30;
		// arr.push(
		// 	<div key={'1hi'} className='bold' style={{height:24,borderBottom:'1px solid rgb(160,160,160)'}}>Media</div>
		// )
		for(let i = 0; i < item.clips.length; i++){
			// let background = 'rgba(0,0,0,0)';
			// if(videoAudio !== ''){
			// 	if(videoAudio.content.name === item.clips[i].name) background = 'rgba(236,236,246,0.3)';
			// }
			vids.push(
				<div key={i} style={{width:width/3-20,height:(width/3-20)*0.6,borderRadius:5,overflow:'hidden',marginRight:10,marginBottom:10,marginTop:10,border:'1px solid rgba(0,0,0,0.2)'}} className='pointer flexCenter'
						onClick={videoClicked}>
					<span className={item.clips[i].spanClass} style={{display:'inline-block',position:'absolute',width:width/3-20,height:(width/3-20)*0.6,opacity:0,zIndex:40}}>&nbsp;</span>
					<div style={{width:width/3-20,height:(width/3-20)*0.6,zIndex:2,backgroundImage:'radial-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0))',
							pointerEvents:'none'}} className='flexCenter absolute'>
						<img src={play_circle} alt='play_circle' style={{height:playHigh}} />
					</div>
					<img src={item.clips[i].still} alt='still' style={{height:'110%'}} className='relative' />
				</div>
			)
			// arr.push(
			// 	<div key={count} className='flexHeightCenter pointer' style={{padding:6,background:background,borderBottom:'1px solid rgb(160,160,160)'}}
			// 			// onClick={()=>{audioAndVideoUpdate({type:'video',content:item.clips[i]})}}
			// 			>
			// 		<span className={item.clips[i].spanClass} style={{display:'inline-block',height:40,position:'absolute',marginLeft:-6,width:width-20,opacity:0}}>&nbsp;</span>
			// 		<div className='flexCenter' style={{width:40}}>
			// 			<img src={video_black} alt='video_black' className='iconSize2' />
			// 		</div>
			// 		<div>
			// 			<div className='tinyText'>Video clip</div>
			// 			<div style={{overflow:'hidden',height:textHeight}}>{item.clips[i].name}</div>
			// 		</div>
			// 	</div>
			// )
			count+=1;
		}
		if(item.youtube_still !== undefined){
			vids.push(
				<div key={'1ni1'} style={{width:width/3-20,height:(width/3-20)*0.6,borderRadius:5,overflow:'hidden',marginRight:10,marginBottom:10,marginTop:10,border:'1px solid rgba(0,0,0,0.2)'}}
						className='pointer flexCenter' onClick={()=>{window.open(item.link)}}>
					<div style={{width:width/3-20,height:(width/3-20)*0.6,zIndex:2,backgroundImage:'radial-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0))',
							pointerEvents:'none'}} className='flexCenter absolute'>
						<img src={play_circle} alt='play_circle' style={{height:playHigh}} />
					</div>
					<img src={item.youtube_still} alt='still' style={{height:'110%'}} className='relative' />
				</div>
			)
		}
		for(let i = 0; i < item.songs.length; i++){
			// let background = 'rgba(0,0,0,0)';
			// if(videoAudio !== ''){
			// 	if(videoAudio.content.name === item.songs[i].name) background = 'rgba(236,236,246,0.3)';
			// }
			arr.push(
				<div key={count}>
					<MusicPlayer2 song={item.songs[i]} i={itt} id={item.songs[i].name} playPressed={playPressed} playing={playing}
							width={width-20} dimensions={dimensions} height={40} item={item} playBack={playBack}
							setPlayBack={setPlayBack} audioRef={audioRef} />
				</div>
			)
			// arr.push(
			// 	<div key={count} className='flexHeightCenter pointer' style={{padding:6,background:background,borderBottom:'1px solid rgb(160,160,160)'}}
			// 			onClick={()=>{audioAndVideoUpdate({type:'audio',content:item.songs[i]})}}>
			// 		<div className='flexCenter' style={{width:40}}>
			// 			<img src={headphones_black} alt='headphones_black' className='iconSize2' />
			// 		</div>
			// 		<div>
			// 			<div className='tinyText'>Audio clip</div>
			// 			<div style={{overflow:'hidden',height:textHeight}}>{item.songs[i].name}</div>
			// 		</div>
			// 	</div>
			// )
			count+=1;
		}
		if(arr.length > 0 || vids.length > 0){
			return(
				<div className='mainText'>
					<div className='bold' style={{height:24,borderBottom:'1px solid rgb(160,160,160)'}}>Media</div>
					<div className='flexHeightCenter'>{vids}</div>
					{arr}
				</div>
			)
		}
		return null
	}

	let marginBottom = 60;
	let detailsHeight = 60;
	if(dimensions.width < 800){
		marginBottom = 40;
		detailsHeight = 40;
	}
	if(dimensions.width < 600) marginBottom = 20;
	return(
		<div style={{marginBottom:marginBottom,borderRadius:6,overflow:'hidden',background:'rgb(190,190,190)',border:'0px solid rgb(150,150,150)',color:'black'}} className='relative'>
		{selected === item.name
			? <div className='absolute flexRight' style={{zIndex:20,width:width,pointerEvents:'none'}}>
				<img src={Cross} alt='Cross' style={{height:40,pointerEvents:'auto',padding:10}} className='pointer'
						onClick={itemClicked} />
			</div>
			: null
		}
		<div className='absolute flexCenter' style={{zIndex:0,height:880,pointerEvents:'none'}}>
			<img src={item.banner} alt='background_pic' style={{height:'100%',filter:'blur(40px)',opacity:0.15}} />
		</div>
		<div style={{borderRadius:6,overflow:'hidden',height:width/2}} onMouseLeave={mouseLeave} onMouseEnter={mouseEnter}
				className='pointer relative' onClick={itemClicked}>
			{/*<div className='heading bold absolute' style={{width:width,height:114,textShadow:'0px 0px 8px rgba(0,0,0,0.6)',
					backgroundImage:'linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0))',color:'white'}}>
				<div style={{margin:12}}>{item.name}</div>
			</div>*/}

			<div className='flexCenter' style={{width:width,height:width/2,background:'black',overflow:'hidden'}}>
				<img src={item.banner} alt='item.thumbnail' style={{width:'100%'}} />
			</div>

			<div style={{width:width,marginTop:-width/2,height:width/2,backgroundImage:'linear-gradient(to right,rgba(0,0,0,0),rgba(0,0,0,0.7))'}} className='absolute flexCenter'>
				<div style={{width:width,color:'white',textAlign:'right'}} className='flexRight '>
					<div style={{width:420,marginRight:20}}>
						<div className='heading bold'>{item.name}</div>
						<div className='subHeading' style={{marginTop:10}}>{item.director}</div>
						{dimensions.width > 600
							? <div className='mainText' style={{marginTop:10}}>{item.description.length > 250 ? item.description.slice(0,250)+'...' : item.description}</div>
							: null
						}
						<div className='flexHeightCenter flexRight' style={{marginTop:30}}>{brandsDisplay2()}</div>
					</div>
				</div>
			</div>
			{(hover === true && selected !== item.name) || dimensions.width < 800
				? <div className='absolute flexCenter underlineHover' style={{width:width,height:detailsHeight,marginTop:-detailsHeight,
						borderTop:'1px solid rgba(255,255,255,0.2)',background:'rgba(0,0,0,0.6)',backdropFilter:'blur(4px)',color:'white'}}>
					{/*{mediaDisplayer()}*/}
					<div className='bold mainText'>More details</div>
				</div>
				: null
			}
		</div>
		{selected === item.name
			? dimensions.width < 940
				? <div style={{padding:10,marginTop:10}}>
					<div style={{marginBottom:10}} className='mainText'>
						{/*<div className='mainText bold'>About</div>*/}
						{informationPoints()}
						{/*<div>Director: {item.director}</div>
						<div>Producer: {item.director}</div>
						<div style={{marginBottom:10}}>Distributor: </div>*/}
						<div style={{height:10}}></div>
						<div className='mainText bold'>About</div>
						<div className='mainText'>{item.description}</div>
						{item.link === undefined || item.link === ''
							? null
							: <div className='mainText flexLeft' style={{marginTop:6}}>
								<div style={{color:'rgb(50,50,190)'}} className='pointer underlineHover' onClick={()=>{window.open(item.link)}}>Learn more</div>
							</div>
						}
						{/*<div className='mainText flexLeft' style={{marginTop:6}}>
							Learn more: <div style={{color:'rgb(50,50,190)',marginLeft:4}} className='pointer' onClick={()=>{window.open(item.link)}}>{item.link}</div>
						</div>*/}
					</div>
					{/*{item.clips[0] !== undefined || item.songs[0] !== undefined
						? <div style={{width:width-10,height:(width)*0.5625,background:'rgb(10,10,10)',marginTop:25,overflow:'hidden'}} className='flexCenter'>
							{videoOrAudio(width-10,(width)*0.5625)}
						</div>
						: null
					}*/}
					{clipsAndMedia()}
				</div>
				: <div style={{padding:10,marginTop:10}}>
					<div className='flexLeft' style={{marginBottom:20}}>
						<div style={{width:'60%'}}>
							<div>
								<div className='mainText bold'>About</div>
								<div className='mainText'>{item.description}</div>
								{item.link === undefined || item.link === ''
									? null
									: <div className='mainText flexLeft' style={{marginTop:8}}>
										<div style={{color:'rgb(50,50,190)'}} className='pointer underlineHover' onClick={()=>{window.open(item.link)}}>Learn more</div>
									</div>
								}
							</div>
							{/*{item.clips[0] !== undefined || item.songs[0] !== undefined
								? <div style={{width:width*0.6-10,height:(width*0.6)*0.5625,background:'rgb(10,10,10)',marginTop:25,overflow:'hidden'}} className='flexCenter'>
									{videoOrAudio(width*0.6-10,(width*0.6)*0.5625)}
								</div>
								: null
							}*/}
						</div>
						<div style={{width:'4%'}} className='flexWidthCenter'>
							<div style={{borderRight:'1px solid rgb(90,90,90)',height:100,marginTop:24}}></div>
						</div>
						<div style={{width:'36%'}}>
							<div className='mainText'>
								{informationPoints()}
								{/*<div className='bold'>Info</div>
								<div>Director: {item.director}</div>
								<div>Producer: {item.director}</div>
								<div>Distributor: </div>*/}
							</div>
						</div>
					</div>
					{clipsAndMedia()}
				</div>
			: null
		}
		{selected === item.name
			? <div className='flexCenter pointer bold mainText underlineHover' style={{marginTop:20,height:detailsHeight,background:'rgba(0,0,0,0.1)',color:'white',borderTop:'1px solid rgb(140,140,140)'}}
					onClick={itemClicked}>
				Collapse
			</div>
			: null
		}
		{/*<BottomPlayBar width={width} playing={playing} playPressed={playPressed} route={'/film'} />*/}
		</div>
	)




	// function brandsDisplay() {
	// 	if(item.brands !== undefined){
	// 		let arr = [];
	// 		for(let i = 0; i < item.brands.length; i++){
	// 			if(BrandsData[item.brands[i]] !== undefined){
	// 				arr.push(
	// 					<div key={i}>
	// 						<img src={BrandsData[item.brands[i]].img} alt='brand' style={{height:20,marginRight:14}} />
	// 					</div>
	// 				)
	// 			}
	// 		}
	// 		return <div className='flexHeightCenter'>{arr}</div>
	// 	}
	// }

	// const imWide = 340;
	// const imHigh = 420;
	// return(
	// 	<div>
	// 	<div className='absolute flexCenter' style={{height:imHigh+2,width:imWide+2,background:'black',borderRadius:14,overflow:'hidden',zIndex:2,pointerEvents:'none'}}>
	// 		<img src={item.thumbnail} alt='item.thumbnail' style={{width:'100%'}} />
	// 	</div>
	// 	<div className='flexLeft listItemContainer pointer' style={{marginBottom:20,height:imHigh}}>
	// 		{/*<div style={{height:160,width:130,background:'black',borderRadius:14,overflow:'hidden'}}></div>*/}
	// 		<div>
	// 			<div className='mainText bold flexHeightCenter' style={{backgroundImage:'linear-gradient(to right,rgba(123,123,173,0.2),rgba(200,230,255,0.2))',
	// 					width:width,height:28,color:'black'}}><div style={{width:imWide+12}}></div>{item.name}</div>
	// 			<div className='flexLeft'>
	// 				<div style={{width:imWide+12}}></div>
	// 				<div>
	// 					{/*<div style={{height:10}}></div>*/}
	// 					{/*<div className='mainText bold'>{item.name}</div>*/}
	// 					<div style={{height:10}}></div>
	// 					<div className='mainText'>{item.director}</div>
	// 					<div style={{height:10}}></div>
	// 					{brandsDisplay()}
	// 				</div>
	// 			</div>
	// 		</div>
	// 	</div>
	// 	</div>
	// )
}

export default ListItem;